import React from 'react';
import CiberSoccontent from '../components/CiberSocContent';
import Footer from '../components/footer';

const CiberSocpage = () => {
  return (
    <div className="Ciberseg">
       
          <CiberSoccontent />
          <Footer />
    </div>
  );
}

export default CiberSocpage;